// extracted by mini-css-extract-plugin
export var delBtn = "meal-type-label-module--del-btn--wyDkD";
export var label = "meal-type-label-module--label--fm8pT";
export var name = "meal-type-label-module--name--tVbk9";